import { render, staticRenderFns } from "./modalCumulRegies.vue?vue&type=template&id=0320d064"
import script from "./modalCumulRegies.vue?vue&type=script&lang=js"
export * from "./modalCumulRegies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports